export default __webpack_public_path__ + "static/media/menu.240b6f84.svg";